export default function moduleInitializer (modules, { mountedModulePrefix = '__' }) {
  if (!document || !window) {
    return
  }
  for (const [moduleName, {
    module,
    listenerOpts = {},
    initHandler = 'init',
    moduleOpts = {}
  }] of Object.entries(modules)) {
    if (window[`${mountedModulePrefix}${moduleName}`]) {
      // console.debug('Module already initialized', moduleName)
      continue
    }
    document.addEventListener('DOMContentLoaded', (e) => {
      // eslint-disable-next-line new-cap
      window[`${mountedModulePrefix}${moduleName}`] = new module(moduleOpts)
      if (initHandler in window[`${mountedModulePrefix}${moduleName}`]) {
        window[`${mountedModulePrefix}${moduleName}`][initHandler]()
      }
    }, listenerOpts)
  }
}
